module.exports = __webpack_public_path__ + "components/country-flag/static/de-e8b4d7df53562bfe459c677b25cffccc.svg";